<template>
  <router-view />
</template>

<script>
import dev from '@/utils/device'
export default {
  name: 'App',
  components: {},
  data() {
    return {
      screenWidth: 0, //document.documentElement.clientWidth, //实时屏幕宽度
      screenHeight: 0, //document.documentElement.clientHeight, //实时屏幕高度
      scrollTop: 0 //document.body.scrollTop,
    }
  },
  created() {},
  watch: {},
  setup() {
    console.log('is_mobile', dev.isMobile())

    let url = window.location.href
    let host = window.location.host
    let http = dev.getProtocol()
    console.log('URL:', url, 'HOST:', host)

    // 移动端检测：如果是手机端且当前域名不是 wap. 开头，则跳转到 wap. 子域名
    if (dev.isMobile() && !host.startsWith('wap.')) {
      let wapUrl = `${http}//wap.${host}${window.location.pathname}${window.location.search}${window.location.hash}`
      window.location.href = wapUrl
      return
    }

    console.log('VALID', url.includes('/tv/signup?code='), url.includes('/?code='))

    //匹配邀请码
    if (url.includes('/tv/signup?code=')) {
      let sort = url.indexOf('code=')
      let code = url.substring(sort)
      if (dev.isMobile()) {
        let url_str = `${http}//wap.${host}/tv/signup?${code}`
        window.location.href = url_str
      } else {
        let url = `${http}//${host}/login?type=invite&${code}`
        window.location.href = url
      }
    }
  },
  mounted() {
    if (this._isMobile()) {
      // console.log('mobile')
    } else {
      // console.log('Windows')
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>
<style scoped>
@import url('@/static/theme.css');
@import url('@/static/lang/lang.css');
</style>
<style>
* {
  box-sizing: border-box;
}

a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
embed,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
main,
mark,
menu,
nav,
object,
ol,
output,
p,
pre,
q,
ruby,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
  border: 0;
  font-size: 100%;
  font: inherit;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
}

li {
  display: list-item;
  unicode-bidi: isolate;
}

menu,
ol,
ul {
  list-style: none;
}

/* 缓慢滚动动画 */
html,
body {
  scroll-behavior: smooth;
  background: var(--background-main-color);
}

/* 隐藏滚动条但保持滚动功能 */
::-webkit-scrollbar {
  display: none;
}

*:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.text-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btnc {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
}

.btnf {
  background: var(--background-color) !important;
  border: 1px solid #ededed !important;
  color: var(--text-color) !important;
}
</style>
